import { gettext } from '@eventbrite/i18n';
import { noop } from 'lodash';
import React from 'react';
import { Timeframe, TrendingSearchResults } from '../types';
import { formatSearchUrl, timeframesMap } from '../utils';

const SearchResults = ({
    searches,
    location,
    displayLocation,
    activeTimeframe,
    shouldNoFollowLinks,
    onClick,
}: TrendingSearchResults) => {
    const _onClick = onClick || noop;
    const optionalLinkProps: { rel?: string } = {};
    let content;

    if (shouldNoFollowLinks) {
        optionalLinkProps.rel = 'nofollow';
    }

    if (searches.length > 0) {
        content = searches.map((value, key) => (
            <div
                key={`${value.formatted}--${value.score}--${activeTimeframe}--${key}`}
                className="eds-g-cell eds-g-cell-12-12 eds-g-cell-md-6-12 eds-g-cell-lg-4-12"
            >
                <p className="trending-search-result eds-l-pad-all-6 eds-l-mar-right-4">
                    <span className="eds-l-mar-right-3">{key + 1}.</span>
                    <a
                        href={formatSearchUrl(location, value.formatted)}
                        onClick={_onClick(value.term)}
                        {...optionalLinkProps}
                    >
                        {value.term}
                    </a>
                </p>
            </div>
        ));
    } else {
        content = (
            <div className="eds-g-cell eds-g-cell-12-12 eds-g-cell-md-12-12 eds-g-cell-lg-12-12">
                <p className="trending-search-result eds-l-pad-all-12 eds-l-mar-right-12">
                    {gettext(
                        'No %(timeframe)s trending searches for %(location)s.',
                        {
                            timeframe:
                                timeframesMap[
                                    activeTimeframe || ('month' as Timeframe)
                                ].toLowerCase(),
                            location: displayLocation,
                        },
                    )}
                </p>
            </div>
        );
    }

    return (
        <div
            id="search-results"
            className="eds-g-group trending-search-results"
        >
            {content}
        </div>
    );
};

export default SearchResults;
